export const IRRIGATION_AREA_LINEAR_PECISION = 3;
export const MAX_IRRIGATION_AREA = 5 * 1000000
export const URL_SEND_EMAIL = `.netlify/functions/send-email`
